import { DmbEnvironment } from '@dmb/dmb-ui';

import { environment } from './environment';

export const provideDmbEnvironment = () =>
  new DmbEnvironment(
    environment.stage,
    environment.production,
    environment.sentryDsn,
    environment.firebaseConfig,
    environment.matomoConfig,
    environment.v2Target,
  );
